import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const FilterToolbar = ({ 
  selectedCategory, 
  onCategoryChange, 
  selectedStyle, 
  onStyleChange,
  showFeaturedOnly,
  onFeaturedToggle,
  onReset
}) => {
  const categoryOptions = [
    { value: 'all', label: 'Все категории' },
    { value: 'halls', label: 'Залы' },
    { value: 'offices', label: 'Офисы' },
    { value: 'coworking', label: 'Коворкинги' },
    { value: 'workstations', label: 'Рабочие места' }
  ];

  const styleOptions = [
    { value: 'all', label: 'Все стили' },
    { value: 'modern', label: 'Современный' },
    { value: 'classic', label: 'Классический' },
    { value: 'minimal', label: 'Минималистичный' },
    { value: 'creative', label: 'Креативный' }
  ];

  const hasActiveFilters = selectedCategory !== 'all' || selectedStyle !== 'all' || showFeaturedOnly;

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-5 lg:p-6 mb-6 md:mb-8">
      <div className="flex flex-col lg:flex-row lg:items-center gap-4">
        <div className="flex items-center gap-2 text-foreground">
          <Icon name="Filter" size={20} />
          <span className="font-medium">Фильтры</span>
        </div>

        <div className="flex-1 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          <Select
            options={categoryOptions}
            value={selectedCategory}
            onChange={onCategoryChange}
            placeholder="Выберите категорию"
          />

          <Select
            options={styleOptions}
            value={selectedStyle}
            onChange={onStyleChange}
            placeholder="Выберите стиль"
          />

          <Button
            variant={showFeaturedOnly ? 'default' : 'outline'}
            fullWidth
            iconName="Star"
            iconPosition="left"
            onClick={onFeaturedToggle}
          >
            {showFeaturedOnly ? 'Показать все' : 'Только популярные'}
          </Button>
        </div>

        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            iconPosition="left"
            onClick={onReset}
          >
            Сбросить
          </Button>
        )}
      </div>
    </div>
  );
};

export default FilterToolbar;